import React, { ReactElement } from "react";
import { ListGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ProjectTask } from ".";
import { ProjectTaskDueDate } from "./ProjectTaskDueDate";

interface IProps {
	tasks: ProjectTask[];
	emptyMessage: string;
}

export const ProjectTaskList = (props: IProps): ReactElement => {
	const history = useHistory();

	if (!props.tasks.length) {
		return <div className="empty-message">{props.emptyMessage}</div>;
	}

	const taskElements = props.tasks.map((task: ProjectTask, index: number) => {
		const safeName =
			task.project && task.project.name ? task.project.name : "Project";
		return (
			<ListGroup.Item
				className="task-list-item"
				key={index}
				onClick={() => history.push(task.getLink)}
			>
				<div className="d-flex align-items-center justify-content-between flex-wrap">
					<div className="d-flex flex-column">
						<span>{task.name}</span>
						<small
							className="text-muted"
							style={{ lineHeight: 1.2 }}
						>
							{safeName}
						</small>
					</div>
					<div className="text-muted">
						<ProjectTaskDueDate task={task} dateFormat="MMM D" />
					</div>
				</div>
			</ListGroup.Item>
		);
	});

	return <ListGroup className="task-list">{taskElements}</ListGroup>;
};
